import { render, staticRenderFns } from "./newContractTemplate.vue?vue&type=template&id=43f84acc&"
import script from "./newContractTemplate.vue?vue&type=script&lang=js&"
export * from "./newContractTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports